import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { useUploadAttachmentMutation } from "../../store/api/attachmentsApi";

const RequestAttachmentModal = ({ open, orderId, onClose, onSuccess }) => {
  const [fileTitle, setFileTitle] = useState("");

  const [uploadAttachment, { isLoading }] = useUploadAttachmentMutation();

  useEffect(() => {
    if (open) {
      setFileTitle("");
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!fileTitle.trim()) {
      toast.error("Please enter attachment title");
      return;
    }

    try {
      await uploadAttachment({
        model_type: "Order",
        model_id: orderId,
        status: 3,
        file_title: fileTitle.trim(),
      }).unwrap();

      toast.success("Attachment request sent successfully");

      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Attachment request failed:", error);

      toast.error(error?.data?.message || "Failed to send attachment request");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Request Attachment</DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Attachment Title"
          placeholder="Enter attachment title"
          value={fileTitle}
          onChange={(e) => setFileTitle(e.target.value)}
          margin="normal"
          disabled={isLoading}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={isLoading || !fileTitle.trim() || !orderId}
        >
          {isLoading ? (
            <>
              <CircularProgress size={18} sx={{ mr: 1 }} />
              Sending...
            </>
          ) : (
            "Send Request"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestAttachmentModal;
